import { contactCreate, contactDelete, contactLoad, contactUpdate, contactUpdateAvatar, contactsByUser, rechargeContactsByUser } from "../../routes/api/paths";
import { handleResponse, requestOptions, requestOptionsFile } from "../HandlerService";

export const ContactsByUserService = async (data) => {
  const { token } = data;
  const options = requestOptions('GET', {}, token);
  return fetch(contactsByUser, options)
    .then(handleResponse)
    .catch(error => Promise.reject({ status: error }));
}

export const contactRechargesByUserService = async (data) => {
  const { token, page, search, status } = data.queryKey[1];
  const body = { page, size: 15 };
  if (search) body.search = search;
  if (status) body.status = status;
  const options = requestOptions('POST', body, token);
  return fetch(rechargeContactsByUser, options)
    .then(handleResponse)
    .catch(error => Promise.reject({ status: error }));
}

export const addContactService = async (data) => {
  const { token, contact } = data;
  const options = requestOptions('POST', contact, token);
  return fetch(contactCreate, options)
    .then(handleResponse)
    .catch(error => Promise.reject({ status: error }));  
}

export const addContactsLoadService = async (data) => {
  const { token, contacts } = data;
  const options = requestOptions('POST', { contacts }, token);
  return fetch(contactLoad, options)
    .then(handleResponse)
    .catch(error => Promise.reject({ status: error }));
}

export const addContactAvatarService = async (data) => {
  const { token, contact } = data;
  const options = requestOptionsFile('POST', contact, token);
  return fetch(contactUpdateAvatar, options)
    .then(handleResponse)
    .catch(error => Promise.reject({ status: error }));  
}

export const updateContactService = async (data) => {
  const { token, contact } = data;
  const options = requestOptions('POST', contact, token);
  return fetch(contactUpdate, options)
    .then(handleResponse)
    .catch(error => Promise.reject({ status: error }));  
}

export const deleteContactService = async (data) => {
  const { token, id } = data;
  const options = requestOptions('DELETE', {id: [id]}, token); // id is an array
  return fetch(contactDelete, options)
    .then(handleResponse)
    .catch(error => Promise.reject({ status: error }));
}